import IEntityWithImage from "./interfaces/iEntityWithImage";

export default class Place implements IEntityWithImage {
    constructor(public id:string, public name:string, public description:string) {}
    public toString(): string { return `${this.name} - ${this.description}`; }
    public promtForPhoto?:string
    public imageId?:string
}